/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {injectIntl} from 'react-intl';
import {Button, Select} from '@scuf/common';
import {FAULT_STATES, SYMPTOM_TYPES, SYMPTOM_STATES} from "../common/FaultsConst";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import AssetTreeSelector from "../AssetTreeSelector";
import * as Airtime from "../../api/Airtime";
import {ASSETS_DATA_SET_TYPE} from "../../admin/assets/AssetsConst";
import {verifyAirtimeException} from "../../utils/Helpers";
import * as Fleets from "../../api/Fleets";
import * as Assets from "../../api/Assets";
import {showNotification} from "../../common/ToastNotification";
import {bindActionCreators} from "redux";
import * as FaultActions from "../FaultActions";
import * as SecurityActions from "../../security/SecurityActions";
import {getUIconfigs, UIconfigNames} from "../../api/UIconfig";

class FaultsFilter extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedAssetId: null,
            hierarchy: [],
            apiPoint: userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY) ? Airtime : Assets,
            observations: [],
            selectedObservations: null,
            symptomsOfInterest: [],
            UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT: false,
            UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS: false,
            UIconfig_SHOW_NEW_FAULT_DISCLAIMER: false,

            disableSubmit: true,
            submitSuccessful: false,
            affectedFaults: [],
            loading: false,
            ldiName: '',

            submittedAutomatically: false,
            failureModeIdentified: null,
        }

        this.alreadyAssigned = " - (" + this.props.intl.formatMessage({id:"fault.report.symptomAssigned"}) + ")";

        this.loadObservations = this.loadObservations.bind(this)
        this.addObservation = this.addObservation.bind(this)
        this.submitReport = this.submitReport.bind(this)
        this.fetchAssets = this.fetchAssets.bind(this)

    }

    componentDidMount() {
        this.fetchAssets()
        getUIconfigs([UIconfigNames.ALLOW_JUST_ONE_SYMPTOM_TO_REPORT, UIconfigNames.JUMP_DIRECTLY_TO_OBSERVATIONS, UIconfigNames.SHOW_NEW_FAULT_DISCLAIMER]).then((response) => {
            const allowOne = response.filter(c => c.name === UIconfigNames.ALLOW_JUST_ONE_SYMPTOM_TO_REPORT)
            const jump = response.filter(c => c.name === UIconfigNames.JUMP_DIRECTLY_TO_OBSERVATIONS)
            const disclaimer = response.filter(c => c.name === UIconfigNames.SHOW_NEW_FAULT_DISCLAIMER)
            this.setState({
                UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT: allowOne.length === 0 ? false : allowOne[0].status === 'ACTIVE',
                UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS: jump.length === 0 ? false : jump[0].status === 'ACTIVE',
                UIconfig_SHOW_NEW_FAULT_DISCLAIMER: disclaimer.length === 0 ? false : disclaimer[0].status === 'ACTIVE',
            })
        })
    }

    fetchAssets() {
        const {userProfile} = this.props

        this.setState({loading: true})

        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.state.apiPoint.fetchAssets(ASSETS_DATA_SET_TYPE.SHALLOW).then(response => {
                this.setState({
                    hierarchy: response,
                    loading: false,
                })
            }).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        } else {
            Fleets.fetchHierarchy(true).then(response => {
                    this.setState({
                        hierarchy: response,
                        loading: false,
                    })
                }
            )
        }
    }

    /**
     * Renders a symptom selector. If UI allows only one symptom to report then it renders select with param multiple
     * as false. Otherwise, we are able to select more symptoms and if there are already some selected observations we
     * get symptoms that are connected to those already selected first, and then we join them with the rest.
     */
    getSelector() {
        const {intl} = this.props
        const disableObservations = !this.state.selectedAssetId;
        let observationsOptions = this.getObservationsOptions(this.state.observations);

        if (this.state.selectedObservations && !this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT) {
            const symptomsOfInterest = this.getObservationsOptions(this.state.symptomsOfInterest)
            if (symptomsOfInterest.length !== 0) {
                observationsOptions = symptomsOfInterest
            }
        }

        return (
            <Select
                placeholder={intl.formatMessage({id: "fault.report.selectSymptom"})}
                options={observationsOptions}
                value={this.state.selectedObservations}
                multiple={!this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT}
                search={!disableObservations}
                fluid
                disabled={disableObservations}
                onChange={(data) => (this.addObservation(data))}
            />
        )
    }

    submitReport(buttonClicked, isUniqueFM) {
        const observations = this.state.selectedObservations.map(id => {
            return {id: id, state: "PRESENT"}
        });
        this.setState({loading: true})
        this.state.apiPoint.submitAssetObservations(this.state.selectedAssetId, observations).then(response => {
            this.resetReport()
            this.setState({
                affectedFaults: response,
                loading: false,
                submittedAutomatically: !buttonClicked,
                failureModeIdentified: isUniqueFM,
            })
        }).catch(ex => {
            if (ex.errorKey === 'business.exception.FAULT_CONDITION_STATE_TRANSITION_REJECTED') {
                this.resetReport();
                this.setState({
                    loading: false
                })
                showNotification({
                    translationPropertyKey: "fault.report.creation.symptom.error",
                    severity: "critical",
                });
            } else {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            }
        });
    }

    /**
     * This function work with only ONE selected symptom
     */
    submitReportForHda() {
        const {history, userProfile} = this.props
        const external = userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)
        const observation = {id: this.state.selectedObservations, state: "PRESENT"};
        this.setState({loading: true})
        this.state.apiPoint.submitAssetObservations(this.state.selectedAssetId, [observation]).then(response => {
            if (response.length === 1 && response[0].faultConditionState === FAULT_STATES.NEW) {
                this.props.FaultActions.setFaultState(this.state.selectedAssetId, response[0].id, FAULT_STATES.IN_PROGRESS, [], null, external).then(() => {
                        external ?
                            history.push(`/airtime/asset/${this.state.selectedAssetId}/faults/${response[0].id}/troubleshooting`)
                            :
                            history.push(`/assets/${this.state.selectedAssetId}/faults/${response[0].id}/troubleshooting`)
                    }
                ).catch(ex => {
                    verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
                })
            } else {
                this.resetReport()
                this.setState({
                    affectedFaults: response,
                    loading: false,
                })
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    getButton() {
        const { intl } = this.props
        return (
            <Button type="primary"
                    content={intl.formatMessage({id: "fault.report.submit"})}
                    disabled={this.state.disableSubmit}
                    onClick={() => {
                        this.props.setLoading()
                        this.state.UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS ?
                            this.submitReportForHda() : this.submitReport(true, null)
                    }}
                    className="mobile-max-width-button"
            />
        )
    }

    addObservation(ids) {
        // If user can enter only one symptom then we don't need to call for possibleFailureModes and symptoms.
        if (this.state.UIconfig_ALLOW_JUST_ONE_SYMPTOM_TO_REPORT || this.state.apiPoint === Airtime) {
            this.setState({selectedObservations: ids, disableSubmit: ids.length === 0})
            return;
        }
        // Empty selection. No api should be called.
        if (ids.length === 0) {
            this.setState({selectedObservations: ids, symptomsOfInterest: [], disableSubmit: ids.length === 0})
            return;
        }
        const submitFunction = this.state.UIconfig_JUMP_DIRECTLY_TO_OBSERVATIONS ? this.submitReportForHda : this.submitReport;

        // If we have enough symptoms to get only one failure mode we create fault
        this.state.apiPoint.fetchPossibleFailureModes(this.state.selectedAssetId, ids)
            .then(failureModes => {
                this.setState({
                    selectedObservations: ids,
                    disableSubmit: ids.length === 0,
                    symptomsOfInterest: []
                }, () => {

                    if (failureModes.length === 1) {
                        submitFunction(false, true);
                        return;
                    }
                    // We didn't have enough symptoms, so we fetch rest of the related symptoms
                    this.state.apiPoint.fetchAssetObservation(this.state.selectedAssetId, [], [], ids)
                        .then(observations => {
                            this.setState({
                                symptomsOfInterest: observations,
                            }, () => {
                                // We cannot further specify failure mode, so we create fault with provided symptoms
                                if (observations.filter(o => o.state !== 'PRESENT').length === ids.length) {
                                    submitFunction(false, false);
                                }
                            })
                        })
                })
            })
    }

    getObservationsOptions(observations) {
        return observations.map(
            o => {
                return {
                    value: o.id,
                    text: this.setDescription(o.description, o.state),
                    disabled: o.state === SYMPTOM_STATES.PRESENT
                }
            }
        )
    }

    setDescription(text, state) {
        return state === SYMPTOM_STATES.PRESENT ? text + this.alreadyAssigned : text;
    }

    loadObservations(assetId) {
        const {userProfile} = this.props
        this.setState({
            selectedAssetId: assetId,
            selectedObservations: null,
            observations: [],
            loading: true,
        })

        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.state.apiPoint.fetchAsset(assetId).then((response) => {
                    if (response.variants.length > 0) {
                        this.setState({ldiName: response.variants[0].ldiName})
                    } else {
                        showNotification({
                            translationPropertyKey: 'admin.asset.notification.noVariantConfiguration',
                            severity: "critical",
                        });
                    }
                }
            ).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        }
        this.state.apiPoint.fetchAssetObservation(assetId, [], [SYMPTOM_TYPES.REPORTED_SYMPTOM, SYMPTOM_TYPES.OBSERVATIONS_TYPE, SYMPTOM_TYPES.HEALTH_INDICATOR_TYPE]).then(
            response => this.setState({
                observations: response,
                loading: false
            })
        ).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    render() {
        return (
            <div>
                <div className={"report-creator"}>
                    <span className={"title"}>Report New Problem</span>
                    <span>Select an Engine model and Primary Symptom to create a new Problem Report</span>
                </div>
                <div className={"search-grid"}>
                    <div className={"search-grid--item"}>
                        <AssetTreeSelector
                            selectionChanged={(id) => {
                                if (id.length > 0) {
                                    this.loadObservations(id[0])
                                } else {
                                    this.setState({selectedAssetId: null})
                                }
                            }}
                            selectedItems={this.state.selectedAssetId ? [this.state.selectedAssetId] : []}
                            hierarchy={this.state.hierarchy}
                            assetCreated={(asset) => {
                                this.fetchAssets()
                                this.loadObservations(asset.id)
                            }}
                            hdaUser={userHasActivity(this.props.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)}
                        />
                    </div>
                    <div className={"search-grid--item"}>
                        {this.getSelector()}
                    </div>
                    <div className={"search-grid--item"}>
                        {this.getButton()}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(FaultsFilter)))